import { render, staticRenderFns } from "./NotificationOverview.vue?vue&type=template&id=0f2264e8&scoped=true&"
import script from "./NotificationOverview.vue?vue&type=script&lang=ts&"
export * from "./NotificationOverview.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationOverview.vue?vue&type=style&index=0&id=0f2264e8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2264e8",
  null
  
)

export default component.exports